/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Auth0Provider} from '@auth0/auth0-react';
import type {AppState} from '@auth0/auth0-react/src/auth0-provider';
import {ReactNode, useContext} from 'react';
import {RuntimeConfigContext} from './RuntimeContextProvider';
import {useAuth0Store} from '../stores/auth0Store';

interface AuthProviderProps {
  children: ReactNode;
}
export const AuthProvider = ({children}: AuthProviderProps) => {
  const runtimeConfig = useContext(RuntimeConfigContext);
  const setAuthState = useAuth0Store((state) => state.setAuthState);

  if (!runtimeConfig) return null;
  const {auth0ClientId, auth0Domain, auth0Audience, auth0Organization} = runtimeConfig;

  const onRedirectCallback = (appState?: AppState) => {
    setAuthState({
      returnTo: appState?.returnTo || null,
      hasRunRedirectCallback: true,
    });
  };

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/auth-callback`,
        organization: auth0Organization,
        audience: auth0Audience,
      }}
      cacheLocation={'localstorage'}
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
